// @ts-ignore
export const AngularApp = window.angular.element(document.querySelector('#zApp'));

export function angularService(serviceName: string): any {
    return AngularApp.injector().get(serviceName);
}

export function angularBroadcast(eventName: string, data: any = {}) {
    return AngularApp.scope().$broadcast(eventName, data);
}

export function angularEmit(eventName: string, data: any = {}) {
    return AngularApp.scope().$emit(eventName, data);
}

export function angularEventOn(eventName, callback) {
    return AngularApp.scope().$on(eventName, callback);
}

export function getCompiledDirective(directiveString: string) {
    const injector = AngularApp.injector();
    let scope;

    const element = injector.invoke([
        '$rootScope',
        '$compile',
        ($rootScope: any, $compile: any) => {
            scope = $rootScope.$new();
            return $compile(directiveString)(scope);
        },
    ]);

    return { element, scope };
}
